import { useState } from 'react';

const PERCENTAGES = [1, 2, 3, 4, 5, 10, 15, 20, 50, 100];

function Pct() {
    const [value, setValue] = useState('');

    const num = parseFloat(value);
    const isValid = !isNaN(num);

    const renderTable = (key) => (
        <table border="1" cellPadding="6" style={{ marginTop: 10 }}>
            <tr>
                <th>%</th>
                <th>-</th>
                <th>+</th>
            </tr>
            {PERCENTAGES.map((pct) => (
                <tr key={`${key}-${pct}`}>
                    <td>{pct}%</td>
                    <td style={{ backgroundColor: '#f8d7da' }}>{isValid ? (num - (num * pct) / 100).toFixed(2) : ''}</td>
                    <td style={{ backgroundColor: '#d4edda' }}>{isValid ? (num + (num * pct) / 100).toFixed(2) : ''}</td>
                </tr>
            ))}
        </table>
    );

    return (
        <div>
            <a href="/">{'<-'} Back</a>
            <h1>Pct</h1>
            <input
                type="number"
                step="any"
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            {renderTable('table')}
        </div>
    );
}

export default Pct;
